export interface ShortcutEntry {
  keys: string;
  action: string;
  actionRu: string;
  scope: 'global' | 'chat' | 'tabs' | 'modal';
  type?: 'keyboard' | 'mouse';
}

const isMac = typeof navigator !== 'undefined' && navigator.platform.toUpperCase().includes('MAC');

export const MOD = isMac ? 'Cmd' : 'Ctrl';

export const SHORTCUTS: ShortcutEntry[] = [
  { keys: `${MOD}+K`, action: 'Open command palette', actionRu: 'Открыть палитру команд', scope: 'global' },
  { keys: `${MOD}+/`, action: 'Keyboard shortcuts', actionRu: 'Горячие клавиши', scope: 'global' },
  { keys: 'Escape', action: 'Close modal / cancel edit', actionRu: 'Закрыть окно / отменить', scope: 'global' },
  { keys: 'Enter', action: 'Send message', actionRu: 'Отправить сообщение', scope: 'chat' },
  { keys: 'Shift+Enter', action: 'New line in message', actionRu: 'Новая строка', scope: 'chat' },
  { keys: 'Middle-click', action: 'Close tab', actionRu: 'Закрыть вкладку', scope: 'tabs', type: 'mouse' },
  { keys: 'Right-click', action: 'Tab context menu', actionRu: 'Контекстное меню вкладки', scope: 'tabs', type: 'mouse' },
  { keys: 'Double-click', action: 'Rename tab', actionRu: 'Переименовать вкладку', scope: 'tabs', type: 'mouse' },
  { keys: 'Drag', action: 'Reorder tabs', actionRu: 'Переместить вкладку', scope: 'tabs', type: 'mouse' },
];
